/* @flow */
// typecheck: ignore file
import _ from 'lodash';
import cx from 'classnames';
import CircleSpinner from 'components/CircleSpinner.jsx';
import Group from 'entities/Group';
import Glyph from 'components/Glyph.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import React from 'react';
import Text from 'components/Text.jsx';
import OrgRoleDropdownMenu from 'groups/components/OrgRoleDropdownMenu.jsx';

import './styles/OrgRoleDropdown.scss';

const NO_ROLE = 'No role';

export type PotentialRole = {
  role: 'student' | 'parent' | 'student' | 'admin',
  display_role: string,
};

type Props = {
  group: Group,
  roles: string[],
  potentialRoles: PotentialRole[],
  canHaveRoleChanged: boolean,
  canHaveRoleInitialized?: boolean,
  onSave?: (userId: number) => void,
  userId: number,
}

type State = {
  open: boolean,
  saving: boolean,
}

class OrgRoleDropdown extends React.Component {
  props: Props;

  state: State = {
    open: false,
    saving: false,
  };

  constructor(props: Props) {
    super(props);
    this.roles = props.roles;
  }

  componentWillReceiveProps(nextProps: Props) {
    if (!_.isEqual(this.props.roles, nextProps.roles)) {
      this.roles = nextProps.roles;
    }
  }

  roles: string[];

  getFormattedRoles() {
    return this.roles.join(', ');
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  onDropdownHide = (roles: string[]) => {
    this.setState({ open: false, saving: !_.isEqual(this.roles, roles) });
    this.roles = roles;
  }

  onSave = () => {
    this.setState({ saving: false });

    if (this.props.onSave) {
      this.props.onSave(this.props.userId);
    }
  }

  renderRoleMenu() {
    const rolesString = this.getFormattedRoles();
    const roleDropdown = (
      <OrgRoleDropdownMenu
        organization={this.props.group.getOrganization()}
        roles={this.roles}
        potentialRoles={this.props.potentialRoles}
        userId={this.props.userId}
        onClose={this.onDropdownHide}
        onSave={this.onSave}
      />
    );
    return (
      <LayerTrigger
        layer={roleDropdown}
        trigger="click"
        placement="bottom"
        alignment="left">
        <div
          className="OrgRoleDropdown-select"
          onClick={() => this.setState({ open: !this.state.open })}>
          <Text color={this.state.saving ? 'eclipse' : 'inherit'}>
            {rolesString.length ?
              <Text truncate capitalize>{rolesString}</Text> :
              <Text truncate className="OrgRoleDropdown-unassigned">{NO_ROLE}</Text>
            }
          </Text>
          {this.state.saving ?
            <CircleSpinner color="shamrock" size="small" /> :
            <Glyph
              name="chevron-down"
              color={this.state.open ? 'brand' : 'thunder'}
              size="xxsmall"
              className="OrgRoleDropdown-select-arrow"
            />
          }
        </div>
      </LayerTrigger>
    );
  }

  renderStaticRoles() {
    const rolesString = this.getFormattedRoles();
    return (
      <span>
        {rolesString ?
          <Text capitalize truncate>{rolesString}</Text> :
          <Text truncate>{NO_ROLE}</Text>
        }
      </span>
    );
  }

  render() {
    const canChange = (
      this.props.canHaveRoleChanged ||
      this.props.canHaveRoleInitialized
    );

    return (
      <div className={cx('OrgRoleDropdown', { 'OrgRoleDropdown--open': this.state.open })}>
        {canChange
          ? this.renderRoleMenu()
          : this.renderStaticRoles()
        }
      </div>
    );
  }

}

export default OrgRoleDropdown;



// WEBPACK FOOTER //
// ./src/groups/components/OrgRoleDropdown.jsx